var map = {
	"./jr_banner.jpg": "66c6",
	"./jr_banner_en.jpg": "49d4",
	"./jr_banner_es.jpg": "c8d1",
	"./jr_banner_hk.jpg": "0aca",
	"./jr_banner_pt.jpg": "f338",
	"./jr_banner_tr.jpg": "4948"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2264";